import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import AppContext from './components/context/AppContext';
import ModalRenderer from './components/context/Modal/ModalRenderer';

import './index.css';

ReactDOM.render(
  <React.StrictMode>
    <AppContext>
      <App />
      <ModalRenderer />
    </AppContext>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
